<script>
	import { onMount } from 'svelte';

	import Loader from '../../atoms/Loader.svelte';
	import Card from '../../molecules/Card/Card.svelte';

	export let page;
	export let ideas;

	let loadingCount = 0,
		hasData = true;

	function loadingCheck(data) {
		if(loadingCount > 0 && !data.length) {
			hasData = false;
			loadingCount = 0;
		}
		loadingCount++;
	}

	onMount(()=> {
		ideas.subscribe(data => loadingCheck(data));
	})

</script>

<style lang="scss" src="./CardList.scss"></style>

<ul class="cardlist">
	{#if hasData}
		{#if $ideas.length}
			{#each $ideas as idea}
				<li>
					<Card 
						docId={idea.id}
						uid={idea.uid}
						title={idea.title}
						text={idea.text}
						timestamp={idea.timestamp}
						media={idea.media}
						isSecured={idea.isSecured}
						saveCount={idea.saveCount}
						messageCount={idea.messageCount}
						page={page}/>
				</li>
			{/each}
		{:else}
			<Loader />
		{/if}
	{:else}
		<li>
			<p class="messages">
				No entries yet
			</p>
		</li>
	{/if}
</ul>